export const getHomepageSectionsQueryOptions = (skip: boolean) => ({
  skip,
  refetchOnMountOrArgChange: true,
})
